import leaveSubItem from "@/api/human-resource/leave-sub-item";
import { baseState, baseMutations } from "@/store/mixins";

export const state = {
    ...baseState,
    leaveTypes: []
};

export const getters = {};

export const mutations = {
    ...baseMutations,
    SET_LEAVE_TYPE(state, data) {
        state.leaveTypes = data;
    }
};

export const actions = {
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        );
        return leaveSubItem.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },

    store(context, data) {
        return leaveSubItem.store(data);
    },

    update(context, { id, data }) {
        return leaveSubItem.update(id, data);
    },

    destroy(context, id) {
        return leaveSubItem.destroy(id);
    },

    async getLeaveType(context, attributes = {}) {
        let response = await leaveSubItem.leaveType({
            params: attributes
        });
        context.commit("SET_LEAVE_TYPE", response.data);
    }
};
